import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SendResetPasswordRequest($email: String!) {
    sendResetPasswordRequest(email: $email) {
      id
      status
    }
  }
`;

export const sendResetPasswordRequest = (email) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { email },
  }).then(({ data }) => getSingleProp(data));
